<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main" v-loading="isLoading">
					<ucMenu num="-1"></ucMenu>
					<div class="right_con">
						<div class="vip_content">
							<p class="title" v-if="current_vip">
								<span style="color: #999;font-weight: normal;">当前会员：</span>
								<span style="font-weight: bold;color: #666;">
									<span style="font-size: 16px;color: #000;">{{current_vip.name}}</span>
									<span style="font-size: 12px;color: #666;margin-left: 10px;" v-if="current_vip.vip_expires_time>0"> 有效期至{{current_vip.vip_expires_time_text}}</span>
								</span>
							</p>
							<div class="subtxt" v-if="current_vip">
								<p style="font-size: 14px;color: #999;margin-top: 10px;">上架费{{current_vip.seeding_fee}}元，采购费{{current_vip.purchase_fee}}元</p>
							</div>
							<p class="title" style="margin-top: 30px;">请选择会员套餐</p>
							<div class="sel_tabs">
								<div class="tab" :class="[{disabled:item.disabled==1},{active:item.id==business_vip_id}]" v-for="(item,index) in vip_list" :key="item.id" @click="bindSelectVip(item,index)">
									<p class="name">{{item.name}}</p>
									<p class="tips">上架费{{item.seeding_fee}}元，采购费{{item.purchase_fee}}元</p>
									<p class="price"><em>{{item.price}}</em>元/{{item.unit}}</p>
								</div>
							</div>
							<div class="pay_type">
								<div class="title">选择支付方式</div>
								<div class="agreement">支付即表示您同意 <a href="/notice?type=6&id=7">《会员服务协议》</a></div>
								<div class="pay_list">
									<el-radio-group v-model="pay_type">
										<div class="pay_item" @click="pay_type=1">
											<img class="icon" src="../../assets/images/credit.png" />
											<span class="name">余额支付</span>
											<span class="desc">(当前可用余额：￥{{credit}})</span>
											<el-radio class="radio" :label="1"></el-radio>
										</div>
										<div class="pay_item" @click="pay_type=2">
											<img class="icon" src="../../assets/images/zhifubao.png" />
											<span class="name">支付宝支付</span>
											<el-radio class="radio" :label="2"></el-radio>
										</div>
									</el-radio-group>
								</div>
							</div>
							<div class="pay_wrap" v-if="select_vip&&checkout_data">
								<div class="price_wrap">
									<span class="price_line">
										<span class="unit">￥</span>
										<span class="price">{{checkout_data.pay_price}}</span>
									</span>
									<div class="tips">{{checkout_data.pay_tips}}</div>
								</div>
								<div class="pay_btn" :class="select_vip?'':'disabled'" @click="bindPay()">{{(type==1?'开通会员':(type==2)?'续费会员':'升级会员')}}</div>
							</div>
							<div class="pay_wrap" v-if="!select_vip||!checkout_data">
								<div class="price_wrap">
									
								</div>
								<div class="pay_btn disabled" @click="bindPay()">开通会员</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<el-dialog :visible.sync="payCodeShow" width="450px" @close="hidePayPopup" :close-on-press-escape="false" :close-on-click-modal="false">
			<div class="pay_popup">
				<p class="title"><img class="icon" src="../../assets/images/zhifubao.png" />支付宝扫码支付</p>
				<img class="code" v-if="paymentCodeImg" :src="paymentCodeImg" />
				<div class="tips" v-if="paymentCodeImg">{{payTitle}}</div>
				<div class="btn_wrap" v-if="!paymentCodeImg">
					<!-- <p class="btn" @click.self="payCodeShow = false">取消</p> -->
					<p class="btn" @click="bindGetPayCode()" >取消</p>
				</div>
			</div>
		</el-dialog>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
export default {
	name: "vipBuy",
	data() {
		return {
			vip_list:[],
			isLoading: false,
			pay_type: 1,//1余额支付，2支付宝支付
			business_vip_id: 0,//选中会员id
			type: 0,//购买类型：1开通，2续费，3升级
			current_vip: null,
			select_vip: null,
			credit: 0,//商家余额
			checkout_data: null,
			paymentCodeImg:"https://admin.v2.xinghaohuo.com/storage/qr_code/99fbf80c1c873d3af2e23486863fbca8.png",
			order_no: '',
			payCodeShow: false,
			payTitle: ''
		}
	},
	components:{
		myHead,myFoot,ucMenu
	},
	computed:{
		...mapState({
			userinfo:(state)=>state.login.userinfo,
		}),
	},
	created(){
		this.init()
		console.log(this.userinfo)
	},
	methods: {
		...mapActions({
			getVipIndex:"ucenter/getVipIndex",
			opVipCheckout:"ucenter/opVipCheckout",
			opVipPay:"ucenter/opVipPay",
			getVipPayState:"ucenter/getVipPayState",
		}),
		init(){
			this.isLoading = true
			this.getVipIndex({data:{},success:(res)=>{
				this.isLoading = false
				if(res.code===200){
					// console.log('get vip list data',res)
					this.vip_list = res.data.business_vip_list
					this.current_vip = res.data.current_vip
					this.credit = res.data.credit
					for(var i in this.vip_list){
						if(this.vip_list[i].is_selected==1){
							this.bindSelectVip(this.vip_list[i],i)
						}
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		bindSelectVip(item,index){
			if(item.disabled == 1){
				return;
			}
			this.business_vip_id = item.id
			this.select_vip = item
			this.type = item.type
			this.vip_list[index].is_selected = 1
			this.checkout()
		},
		//检出支付金额
		checkout(){
			let params = {business_vip_id: this.business_vip_id,pay_type: this.pay_type,type: this.select_vip.type}
			this.opVipCheckout({data:params,success:(res)=>{
				if(res.code===200){
					// console.log('checkout data',res)
					this.checkout_data = res.data
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		//支付会员
		bindPay(){
			let that = this
			if(!that.select_vip){
				that.$message({message: '请选择会员套餐',type: 'info'});
				return
			}
			if(that.isLoading) return;
			this.$confirm('确定开通会员套餐?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				that.isLoading = true
				let select_vip = that.select_vip
				let params = {business_vip_id: that.business_vip_id,pay_type: that.pay_type,type: that.select_vip.type}
				that.opVipPay({data:params,success:(res)=>{
					that.isLoading = false
					if(res.code===200){
						// console.log('vip pay data',res)
						
						if(that.pay_type == 1){
							that.$message({message: res.msg,type: 'success'});
							setTimeout(function(){
								window.location.reload()
							},1000)
						}else{
							that.payTitle = res.data.title
							that.paymentCodeImg = res.data.qr_code_url
							that.order_no = res.data.order_no
							that.payCodeShow = true
							that.checkPayState()
						}
						
					} else {
						that.$message({message: res.msg,type: 'error',});
					}
				}})
			}).catch((res) => {
				console.log(res)
			});
		},
		checkPayState(){
			let that = this
			if(!this.payCodeShow||!this.order_no){
				return
			}
			this.getVipPayState({data:{order_no:this.order_no},success:(res)=>{
				if(res.code===200){
					// console.log('get check state',res)
					if(res.data == 1){
						this.$message({message: '支付成功',type: 'success'});
						setTimeout(function(){
							window.location.reload()
						},1000)
						
					}else{
						setTimeout(function(){
							that.checkPayState()
						},2000)
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		hidePayPopup(){
			this.payTitle = ""
			this.paymentCodeImg = ""
			this.order_no = ""
			this.payCodeShow = false
		}
	}
}
</script>

<style scoped>
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}
.center{display: flex;flex: 1;}
.right_con{width: 980px;background: #fff;}
.vip_content{padding: 30px 40px;background: #fff;line-height: 1;color: #333;}
.vip_content .title{font-size: 16px;font-weight: bold;color: #333;}
.vip_content .subtxt{font-size: 16px;margin-top: 15px;border-bottom: 1px solid #eee;padding-bottom: 10px;}
.vip_content .sel_tabs{margin-top: 20px;display: grid;grid-template-columns: repeat(3, 1fr);gap: 20px;}
.vip_content .sel_tabs .tab{width: auto;box-sizing: border-box;border: 3px solid #ccc;cursor: pointer;text-align: center;border-radius: 20px;padding-bottom: 16px;}
.vip_content .sel_tabs .tab:first-child{cursor: unset;}
.vip_content .sel_tabs .tab .tips{color: #999999;font-size: 12px;margin-top: 10px;}
.vip_content .sel_tabs .tab.active{border: 3px solid #e4393c;}
.vip_content .sel_tabs .tab .name{font-size: 20px;margin-top: 14px;}
.vip_content .sel_tabs .tab .price{margin-top: 25px;font-size: 16px;color: #999;}
.vip_content .sel_tabs .tab .price>em{font-size: 40px;color: #333333;}
.vip_content .sel_tabs .tab.active .price{color: #e4393c;}
.vip_content .sel_tabs .tab.active .price>em{color: #e4393c;}
.vip_content .sel_tabs .tab.disabled{background-color: #f2f2f2;}

.vip_content .pay_type{display: flex;flex-direction: column;position: relative;}
.vip_content .pay_type .agreement{position: absolute;font-size: 12px;color: #666666;right: 0px;top: 30px;white-space: nowrap;}
.vip_content .pay_type .agreement a{font-size: 12px;color: #fb5758;}
.vip_content .pay_type .title{font-size: 16px;color: #666;margin-top: 30px;white-space: nowrap;}
.vip_content .pay_type .pay_list{display: flex;flex-direction: column;margin-top: 20px;}
.vip_content .pay_type .pay_list .pay_item{display: flex;align-items: center;height: 70px;align-items: center;border-bottom: 1px solid #f2f2f2;gap: 10px;width: 100%;position: relative;cursor: pointer;}
.vip_content .pay_type .pay_list .pay_item:last-child{border: unset;}
.vip_content .pay_type .pay_list .pay_item .icon{width: 24px;height: 24px;border-radius: 5px;}
.vip_content .pay_type .pay_list .pay_item .name{font-size: 16px;}
.vip_content .pay_type .pay_list .pay_item .desc{font-size: 12px;color: #999999;padding-top: 4px;}
.vip_content .pay_type .pay_list .pay_item .radio{position: absolute;right: 20px;}
.vip_content .pay_wrap{display: flex;align-items: center;width:100%;align-items: center;justify-content: space-between;margin-top: 30px;bottom: 0;background-color: #fff;position: sticky;bottom: 0;padding: 20px 0;border-top: 1px solid #eee}
.vip_content .pay_wrap .price_wrap{display: flex;flex-direction: column;}
.vip_content .pay_wrap .price_wrap .price_line{display: flex;align-items: flex-end;}
.vip_content .pay_wrap .price_wrap .price_line .unit{font-size: 14px;color: #fb5758;}
.vip_content .pay_wrap .price_wrap .price_line .price{font-size: 24px;color: #fb5758;}
.vip_content .pay_wrap .tips{font-size: 14px;color: #888;margin-top: 6px;}
.vip_content .pay_wrap .tips .money{font-size: 14px;color: #fb5758;}
.vip_content .pay_wrap .pay_btn{width: 140px;height: 46px;background-color: #fb5758;border-radius: 23px;display: flex;align-items: center;justify-content: center;color: #ffffff;font-size: 14px;cursor: pointer;}
.vip_content .pay_wrap .pay_btn.disabled{background-color: #ccc !important;}

.pay_popup{box-sizing: border-box;background: #fff;}
.pay_popup .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.pay_popup .title{display: flex;align-items: center;margin: 0 22px;font-size: 20px;line-height: 1;}
.pay_popup .title .icon{width: 22px;height: 22px;margin-right: 8px;}
.pay_popup .input_line{margin: 15px 22px 0;display: flex;align-items: center;}
.pay_popup .input_line .txt{font-size: 12px;color: #666666;margin-right: 10px;}
.pay_popup .input_line .in{width: auto;}
.pay_popup .code{width: 155px;height: auto;display: block;margin: 30px auto 0;}
.pay_popup .tips{margin-top: 10px;text-align: center;font-size: 18px;color: #e4393c;}
.pay_popup .btn_wrap{margin: 45px 0 0;display: flex;justify-content: space-around;}
.pay_popup .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.pay_popup .btn_wrap .btn:nth-child(2){border: 1px solid #dddddd;color: #333;}
.pay_popup .btn_wrap .btn:nth-child(1){background: #f0413e;color: #fff;}
</style>
<style>
.page_links{line-height: 1;font-size: 14px;color: #999999;display: flex;margin-top: 25px;}
.page_links .el-breadcrumb__inner{font-weight: bold !important;color: #333 !important;}
.page_links .el-breadcrumb__inner.is-link{font-weight: initial !important;color: #999 !important;}
.page_links .el-breadcrumb__inner.is-link:hover{color: #f0423f !important;text-decoration: underline;}
.el-table .el-table_1_column_2 .cell .num{color: #999;}

.el-radio__label{display: none;}
</style>